import { useEffect } from 'react';
import { useUserContext } from '@osmosis/nextjs-components/context/UserContext';
import { usePagesContext } from '@osmosis/nextjs-components/context/PagesProvider';
import { UserProps } from '@elsevier-health/osmosis-shared/types/user';
import { track } from '../lib/util/tracking';

type UserType = 'guest' | 'b2b' | 'b2c';

/**
 * Determines the tracking user type based on sign-in and active product.
 */
const getUserType = (user?: UserProps | null): UserType => {
  if (!user?.userID) return 'guest';
  return user.prime?.isActiveProductB2B ? 'b2b' : 'b2c';
};

/**
 * Hook to track page view.
 * It tracks the page view event with the current page URL and referrer.
 * It only runs on the client side and when the user is loaded.
 */
const usePageView = () => {
  const { isUserLoaded, user } = useUserContext();
  const { pathname } = usePagesContext();

  useEffect(() => {
    if (!isUserLoaded || typeof window === 'undefined') return;

    const properties = {
      referrer: document.referrer,
      page_url: window.location.href,
      userID: user?.userID || 0,
      user_type: getUserType(user),
    };

    void track('page_view', properties, ['keen', 'gtm']);
  }, [isUserLoaded, pathname]);
};

export default usePageView;
